/**
 * Hydrates AI assist settings and plan entitlement cache when workspace changes.
 */

import { useEffect } from 'react';
import { useTenantStore } from '../../stores/prioritization/tenantStore';
import { useAiAssistSettingsStore } from '../../stores/prioritization/aiAssistSettingsStore';
import { hydrateWorkspacePlanCache, clearAssistSettingsCache } from '../../lib/ai/aiAssistSettings';

export function AiAssistBootstrap() {
  const workspaceId = useTenantStore((s) => s.currentWorkspaceId);
  const workspacePlan = useTenantStore((s) => s.workspacePlan);
  const fetchWorkspacePlan = useTenantStore((s) => s.fetchWorkspacePlan);
  const fetchAll = useAiAssistSettingsStore((s) => s.fetchAll);

  useEffect(() => {
    hydrateWorkspacePlanCache(workspacePlan);
  }, [workspacePlan]);

  useEffect(() => {
    if (!workspaceId) {
      clearAssistSettingsCache();
      return;
    }
    void fetchWorkspacePlan(workspaceId);
    void fetchAll(workspaceId);
  }, [workspaceId, fetchWorkspacePlan, fetchAll]);

  return null;
}
